// extracted by mini-css-extract-plugin
export default {"modal-header":"TpnLoginModal_modal-header__8C1vL","modal-action":"TpnLoginModal_modal-action__zLmFw"};